import { createQueryKeys } from '@lukemorales/query-key-factory';
import type {
  BjListParams,
  FetchLiveBookmarkParams,
  FetchLiveFanParams,
  FetchLiveGiftParams,
  FetchLiveRoomRankParams,
  FetchLiveUpcomingParams,
  FetchLiveWatchParams,
  FetchMemberInfoParams,
  LiveParams,
  LiveRankingParams,
  PlayUserCountParams,
} from '@module/apis/client-side/live/type';

export const liveQueryKeys = createQueryKeys('live', {
  fetchLive: ({ offset, limit, orderBy, onlyNewBj }) => [offset, limit, orderBy, onlyNewBj],
  fetchLiveInfinite: (fetchLiveParams: LiveParams) => [fetchLiveParams],
  fetchLiveFanInfinite: (fetchLiveFanParams: FetchLiveFanParams) => [fetchLiveFanParams],
  fetchLiveGiftInfinite: (fetchLiveGiftParams: FetchLiveGiftParams) => [fetchLiveGiftParams],
  fetchLiveWatchInfinite: (fetchLiveWatchParams: FetchLiveWatchParams) => [fetchLiveWatchParams],
  fetchLiveBookmarkInfinite: (fetchLiveBookmarkParams: FetchLiveBookmarkParams) => [fetchLiveBookmarkParams],
  fetchLiveRanking: (fetchLiveRankingPrams: LiveRankingParams) => [fetchLiveRankingPrams],
  fetchLiveRankingInfinite: (fetchLiveRankingPrams: LiveRankingParams) => [fetchLiveRankingPrams],
  fetchLivePlaycount: (params: PlayUserCountParams) => ['fetchLivePlaycount', params],
  postRecommend: () => ['postRecommend'],
  postLiveSpon: () => ['postLiveSpon'],
  postLiveExcelSpon: () => ['postLiveExcelSpon'],
  livePlay: () => ['livePlay'],
  liveUrl: () => ['liveUrl'],
  fetchMemberinfo: (params?: FetchMemberInfoParams) => ['fetchMemeberInfo', params],
  fetchLiveRoomRank: (fetchLiveRoomRankParams: FetchLiveRoomRankParams) => [fetchLiveRoomRankParams],
  fetchLiveRoomRankList: () => ['fetchLiveRoomRankList'],
  fetchBjList: (fetchBjListParams: BjListParams) => [fetchBjListParams],
  fetchFanHideAdd: () => ['fetchFanHideAdd'],
  fetchFanHideDelete: () => ['fetchFanHideDelete'],
  fetchWatchDelete: () => ['fetchWatchDelete'],
  passedPassword: () => ['passedPassword'],
  fetchBjNotice: (fetchBjNoticeParams) => [fetchBjNoticeParams],
  fetchLiveUpcoming: (fetchLiveUpcomingParams: FetchLiveUpcomingParams) => [fetchLiveUpcomingParams],
  fetchRandomMedia: () => ['fetchRandomMedia'],
});
